export enum WorkplaceStaleTimeEnum {
  GetWorkplaces = 60000,
  GetOldScheduler = 60000,
}
